import * as _ from 'lodash'
import { getGameScoreByIds } from "@common/helpers/requests/gameScores";
import { swarmRequest } from "@common/helpers/util/requestMiddleware";

const getFinishedGameScores = async (gameIds) => {
  if (!gameIds.length) return {};

  const matches = await swarmRequest({ match_id_list: [...new Set(gameIds)] }, 'get_match_scores');

  return (
    matches.details?.reduce((acc, item) => ({ ...acc, [item.match_id]: item.score }), {})
  ) || {};
}

const getLiveGameScores = async (gameIds) => {
  if (!gameIds.length) return {};

  const { data: { game } } = await swarmRequest(getGameScoreByIds([...new Set(gameIds)]), 'get');

  return game ? _.mapValues(game, (val) => val.text_info) : {};
}

export const getScoresForSelections = async (selectionList) => {
  const liveGameIds = selectionList.filter(item => item.is_live).map(item => item.match_id);

  const finishedGameIds = selectionList.filter(item => {
    const startTimePassed = new Date().getTime() > new Date(item.start_time).getTime();
    return startTimePassed && !item.is_live;
  }).map(item => item.match_id);

  return {
    ...await getLiveGameScores(liveGameIds),
    ...await getFinishedGameScores(finishedGameIds),
  };
}